// extracted by mini-css-extract-plugin
export default {"modalOverlay":"EditModal_modalOverlay__4g9SU","modal":"EditModal_modal__tlwUL","closeButton":"EditModal_closeButton__B5ToB"};